export const appConfig = {
  sendGridApiKey: "",
  API: {
    URL: "https://api.yasmina.com",
    KEY: "64c4ea19-c706-49e5-bfb5-6e7da2adca7d",
  },
  /*
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },*/
};
